module.exports = __webpack_public_path__ + "static/create-and-share-f7ccc5fb9e3b2cdf6300689067529b95.jpg";